import Table from "@/common/components/Table";
import { companyFeeColumns } from "@/features/privateCompanies/constants/companyFeeColumns.constant";
import { useCompanyGroupedFee } from "@/features/privateCompanies/hooks/useCompanyGroupedFee";
import { useTransactionIdentifiersEventsFees } from "@/features/privateCompanies/hooks/useTransactionIdentifiersEventsFees";
import { CompanyFeeTransformer } from "@/features/privateCompanies/services/companyFeeTransnformer";

interface EventFeeTableProps { 
  eventId: string, 
  transactionId?: string,
  kind?: 'client' | 'establishment'; 
}

export const EventFeeTable = ({ eventId, transactionId = '', kind }: EventFeeTableProps) => {
  const { data: clientGroupedFees, isFetching: groupedFeeIsFetching } = useCompanyGroupedFee(eventId, kind === 'client');
  const { data: establishmentGroupedFee, isFetching: establishmentGroupedFeeIsFetching } = useTransactionIdentifiersEventsFees(transactionId, kind === 'establishment');

  const establishmentGroupedFees = establishmentGroupedFee?.establishment_fees?.grouped_by_source

  const groupedFees = kind === 'client' ? clientGroupedFees : establishmentGroupedFees

  return (
    <div className="mb-4 last:mb-0">
      <Table
        className="rounded-none"
        columns={companyFeeColumns}
        rows={CompanyFeeTransformer.tableTransformer()(groupedFees) || []}
        rowEmptyValue="--"
        page={1}
        totalPages={1}
        loadingRows={3}
        isLoadingData={groupedFeeIsFetching || establishmentGroupedFeeIsFetching}
        emptyDataClassName="max-h-[217px]"
        emptyDataImageHeight={120}
      />
    </div>
  );
};